import requests from "./httpService";

const CashEntryServices = {
  // CashMaker submits multiple entry rows.
  createCashEntries: async (body) => {
    return requests.post("/site-cash-entries", body);
  },

  // Fetch entries using optional filters.
  getCashEntries: async (filters = {}) => {
    const params = new URLSearchParams();

    ["storeId", "passbookId", "entryType", "status"].forEach(
      (key) => {
        const value = filters[key];

        if (
          value !== undefined &&
          value !== null &&
          value !== ""
        ) {
          params.set(key, String(value));
        }
      }
    );

    const query = params.toString();

    return requests.get(
      `/site-cash-entries${query ? `?${query}` : ""}`
    );
  },

  // CashChecker approves or rejects an entry.
  reviewByAdmin: async (id, body) => {
    return requests.patch(
      `/site-cash-entries/${encodeURIComponent(id)}/admin-review`,
      body
    );
  },

  // Accounts approves or rejects an entry.
  reviewByAccounts: async (id, body) => {
    return requests.patch(
      `/site-cash-entries/${encodeURIComponent(id)}/accounts-review`,
      body
    );
  }
};

export default CashEntryServices;